<app-modal-filler-atom
  (click)="close()"
  [index]="(index$ | async) ?? 0"
></app-modal-filler-atom>
<div
  class="fixed left-0 right-0 overflow-y-auto shadow md:left-0 md:top-0 md:flex md:h-full md:w-full md:items-center md:justify-center mdMax:mx-auto mdMax:max-h-85-screen mdMax:max-w-screen-sm"
  [style.z-index]="((index$ | async) ?? 0) + 50"
  [style.bottom.px]="keyboardOffset"
  [class.mdMax:bottom-0]="keyboardOffset === 0"
>
  @if (isDesktop$ | async) {
    <app-modal-filler-atom
      [withBackdrop]="false"
      (click)="close()"
      [index]="(index$ | async) ?? 0"
    ></app-modal-filler-atom>
  }
  <div
    class="rounded-t-3xl p-5 md:w-3/5 md:max-w-lg md:rounded-3xl md:p-7" [style.backgroundColor]="backgroundColor | contentBuilderColor: '#FFFFFF'"
    [style.z-index]="((index$ | async) ?? 0) + 50"
  >
    <h1
      class="pb-5 font-brand text-28px font-bold text-neutral-800"
      translate="zerosix.create-account.header"
    ></h1>
    @if (step === 'join-form') {
      <div class="relative pb-6">
        <app-kiosk-input-country-phone-atom
          id="zerosixRegistrationPhoneInput"
          [phone]="phone()"
          [useLocalFormat]="false"
          [defaultRegionCode]="defaultRegionCode()"
          (updatePhone)="phone.set($any($event))"
          (keyup.enter)="onSubmit()"
        />
      </div>
      <div class="flex flex-col">
        @if (errorMessage) {
          <div class="self-center">
            <span
              class="font-base text-xs font-normal text-error-700"
              [translate]="errorMessage"
            ></span>
          </div>
        }
        @if (phoneErrorMessage === 'zerosix.create-account.errors.account-already-exists') {
          <div class="pb-4">
            <app-button-atom
              size="M"
              [label]="'zerosix.create-account.connect-with-loyalty-account' | translate"
              (click)="openLinkWithLoyaltyAccountModal()"
              type="light"
              [full]="true"
            ></app-button-atom>
          </div>
        }
        <div class="flex gap-2 pt-1 xm:flex-nowrap">
          <div class="w-full xm:w-1/2">
            <app-button-atom
              size="M"
              [label]="'zerosix.cancel' | translate"
              (click)="close()"
              type="light"
              [full]="true"
            ></app-button-atom>
          </div>
          <div class="w-full xm:w-1/2">
            <app-button-atom
              [iconUrl]="isValidating ? 'assets/images/spinner.svg' : ''"
              [disabled]="isValidating || !this.phone()"
              size="M"
              [label]="'zerosix.validate' | translate"
              type="primary"
              [full]="true"
              (click)="onSubmit()"
            ></app-button-atom>
          </div>
        </div>
      </div>
    }

    @if (step === 'confirmation') {
      <div class="flex flex-col gap-10">
        <p class="mb-0.5 flex items-center font-base text-base text-neutral-800">
          <span><i class="icon icon-n-check mr-1.5 mt-1 text-xl text-success-600"></i></span>
          {{ 'zerosix.create-account.success-message' | translate }}
        </p>
        <app-button-atom
          size="L"
          [label]="'zerosix.validate' | translate"
          type="primary"
          [full]="true"
          (click)="close()"
        ></app-button-atom>
      </div>
    }
  </div>
</div>
